module.exports = __webpack_public_path__ + "static/media/logo blue.c6ef1577.jpg";